import React, { Component } from "react";
import "./Events.css";
import Event from "./events/Event";
import axios from "axios";

class Events extends Component {
	constructor(props) {
		super(props);

		this.state = {
			events: []
		};

		let calendarId = "c_pr787al901j49df22ejr76gb50@group.calendar.google.com";
		let apiKey = "AIzaSyCzlc3c_lHNrg6cM2hFon-fbGnunENMKVo";
		let url = "https://www.googleapis.com/calendar/v3/calendars/" + calendarId + "/events?key=" + apiKey;
		let self = this;
		axios.get(url)
			.then(res => {
				let items = self.orderByDate(res.data.items, "start", "dateTime");
				self.setState({
					events: items
				});
				console.log(self.state);
			}
		)
	}

	orderByDate(arr, dateProp, dateProp2) {
		return arr.slice().sort(function (a, b) {
			return a[dateProp][dateProp2] < b[dateProp][dateProp2] ? 1 : -1;
		});
	}

	render() {
		const hasEvents = this.state && this.state.events.length > 0;
		return (
			<div className="nf-page">
				<div className="nf-page-head">
					<p className="nf-eyebrow">Readings, launches &amp; appearances</p>
					<h1>Events</h1>
				</div>
				<div className="nf-entries">
					{hasEvents ? (
						this.state.events.map((event) => <Event key={event.id} event={event} />)
					) : (
						<p className="site-text">No events on the calendar right now — check back soon.</p>
					)}
				</div>
			</div>
		);
	}
}

export default Events;
